import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "../../Asset/scss/takemyyacht.scss";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import Kbank from "../../Asset/image/yacht/Kasikornbank_Logo.svg.png";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import {
  getBookingDetail,
  createPaymentBillAction,
  getPaymentBookingAction,
  completeBookingAction,
  getYachtAction,
  getBookCustomerDetailAction,
  getAllBookingAction,
} from "../../redux/booking/BookingSlice";
import {
  sendEmailPaymentAction,
  uploadSlipAction,
} from "../../redux/Auth/AuthSlice";
import { updateUsePromotionAction } from "../../redux/promotion/PromotionSlice";
import {
  getNationalityDetail,
  getPaymentConnectionDetail,
} from "../../redux/centerData/CenterDataSlice";
import { useTranslation } from "react-i18next";

const PaymentModal = ({
  show,
  onHide,
  onCloseMainModal,
  bookingId,
  booking,
}) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.AuthSlice.token);
  const [loading, setLoading] = useState(true);
  const todos = useSelector((state) => state);
  const { t } = useTranslation();
  const [omiseLoaded, setOmiseLoaded] = useState(false);
  const [promoUsed, setPromoUsed] = useState(false);

  useEffect(() => {
    if (!window.Omise) {
      const script = document.createElement("script");
      script.src = "https://cdn.omise.co/omise.js";
      script.onload = () => setOmiseLoaded(true);
      document.body.appendChild(script);
    } else {
      setOmiseLoaded(true);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          dispatch(getBookingDetail({})),
          dispatch(getPaymentBookingAction({})),
          dispatch(getYachtAction({})),
          dispatch(getBookCustomerDetailAction({}, token)),
          dispatch(getAllBookingAction({}, token)),
          dispatch(getNationalityDetail({})),
          dispatch(getPaymentConnectionDetail()),
        ]);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const paymentConnections = todos.CenterDataSlice.PaymentConnection?.results;

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(getPaymentBookingAction({}));
      dispatch(getAllBookingAction({}, token));
    }, 5000);

    return () => clearInterval(intervalId);
  }, [dispatch, token]);

  const [paymentMethod, setPaymentMethod] = useState("Credit / Debit Cards");
  const [slipFile, setSlipFile] = useState(null);
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryMonth, setExpiryMonth] = useState("");
  const [expiryYear, setExpiryYear] = useState("");
  const [cvv, setCvv] = useState("");
  const [focus, setFocus] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const handleFileChange = (e) => {
    setSlipFile(e.target.files[0]);
  };

  const resizeImageToBase64 = (
    file,
    maxWidth = 800,
    maxHeight = 800,
    quality = 0.4
  ) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height;

            if (aspectRatio > 1) {
              width = maxWidth;
              height = Math.round(maxWidth / aspectRatio);
            } else {
              height = maxHeight;
              width = Math.round(maxHeight * aspectRatio);
            }
          }

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          const base64 = canvas.toDataURL("image/jpeg", quality);

          resolve(base64);
        };

        img.onerror = (err) => reject(err);
      };

      reader.onerror = (err) => reject(err);
    });
  };

  const showSnackbar = (message, severity = "info") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const createOmiseToken = (cardData) => {
    return new Promise((resolve, reject) => {
      if (!window.Omise) {
        reject(new Error("Omise.js not loaded"));
        return;
      }

      window.Omise.createToken("card", cardData, (statusCode, response) => {
        if (response.object === "error") {
          reject(new Error(response.message));
        } else {
          resolve(response.id); // คืนค่า token
        }
      });
    });
  };

  const handleSubmit = async () => {
    if (!paymentMethod) {
      showSnackbar(t("Please select a payment method."), "warning");
      return;
    }

    try {
      // ================= หา booking =================
      const bookingAllData = todos?.Booking?.bookingAllResult?.data || [];

      const matchedBooking = bookingAllData.find(
        (b) => Number(b.id_booking) === Number(bookingId)
      );

      if (!matchedBooking) {
        showSnackbar("Booking not found", "error");
        return;
      }

      // ================= หา payment =================
      const paymentData = todos?.Booking?.paymentBookingResult?.data || [];

      const matchedPayment = paymentData.find(
        (item) => Number(item.id_booking) === Number(bookingId)
      );

      if (!matchedPayment) {
        showSnackbar("Payment booking not found", "error");
        return;
      }

      const id_payment_booking = matchedPayment.id_payment_booking;

      let base64Image = null;
      let creditCardToken = null;

      // ================= BANK TRANSFER =================
      if (paymentMethod === "Bank Transfer") {
        if (!slipFile) {
          showSnackbar(t("Please attach your proof of payment."), "warning");
          return;
        }

        base64Image = await resizeImageToBase64(slipFile, 800, 800, 0.4);

        const payload = {
          payment_type: paymentMethod,
          value_amount: matchedBooking.sum_all_price,
          cash_receive_money: matchedBooking.sum_all_price,
          credit_card_no: null,
          id_credit_card_type: null,
          credit_card_token: null,
          sum_payment_bill: matchedBooking.sum_all_price,
          id_payment_booking,
          id_yacht: matchedBooking.id_yacht,
          id_booking: bookingId,
        };

        const result = await dispatch(createPaymentBillAction(payload));
        if (!result?.status) {
          showSnackbar("Create payment bill failed", "error");
          return;
        }

        const uploadResult = await dispatch(
          uploadSlipAction({
            id_booking: bookingId,
            payment_slip: base64Image,
            token,
          })
        );

        if (!uploadResult?.status) {
          showSnackbar("Upload slip failed", "error");
          return;
        }
      }

      // ================= CREDIT CARD =================
      if (paymentMethod === "Credit / Debit Cards") {
        if (!window.Omise) {
          showSnackbar("Omise not loaded", "error");
          return;
        }

        const creditObj = JSON.parse(
          todos?.CenterDataSlice?.PaymentConnection?.results?.[0]?.credit || "{}"
        );

        if (!creditObj?.enable) {
          showSnackbar("Credit card not enabled", "error");
          return;
        }

        window.Omise.setPublicKey(creditObj.public_key);

        creditCardToken = await createOmiseToken({
          name: cardName,
          number: cardNumber,
          expiration_month: expiryMonth,
          expiration_year: expiryYear,
          security_code: cvv,
        });

        if (!creditCardToken) {
          showSnackbar("Token failed", "error");
          return;
        }

        const payload = {
          payment_type: paymentMethod,
          value_amount: matchedBooking.sum_all_price,
          cash_receive_money: matchedBooking.sum_all_price,
          credit_card_no: cardNumber.slice(-4),
          id_credit_card_type: "0000000005",
          credit_card_token: creditCardToken,
          sum_payment_bill: matchedBooking.sum_all_price,
          id_payment_booking,
          id_yacht: matchedBooking.id_yacht,
          id_booking: bookingId,
        };

        const result = await dispatch(createPaymentBillAction(payload));
        if (!result?.status) {
          showSnackbar("Create payment bill failed", "error");
          return;
        }
      }

      // ================= COMPLETE BOOKING =================
      const completeResult = await dispatch(
        completeBookingAction({
          id_booking: bookingId,
          id_payment_booking,
        })
      );

      if (!completeResult?.status) {
        showSnackbar("Complete booking failed", "warning");
        return;
      }

      // ================= PROMOTION =================
      try {
        const bookPromo = todos?.Booking?.Booking?.results || [];

        const matchedPromo = bookPromo.find(
          (b) => Number(b.id_booking) === Number(bookingId)
        );

        if (matchedPromo?.use_promo) {
          await dispatch(
            updateUsePromotionAction({
              promotion_code: matchedPromo.use_promo,
              token,
            })
          );
        }
      } catch (e) {
        console.warn("Promo error:", e);
      }

      // ================= EMAIL =================
      try {
        const yachtOwnerData = todos?.Booking?.yachtResult?.data?.find(
          (y) => Number(y.id_yacht) === Number(matchedBooking.id_yacht)
        );

        const yachtOwnerEmail = yachtOwnerData?.email;

        if (!yachtOwnerEmail) {
          console.warn("No yacht owner email");
        } else {
          const resultCustomerDetail = await dispatch(
            getBookCustomerDetailAction({}, token)
          );

          const updatedList = resultCustomerDetail?.data || [];

          const passengersForBooking = updatedList.filter(
            (c) => Number(c.id_booking) === Number(bookingId)
          );

          const nationalityList =
            todos?.CenterDataSlice?.Nationality?.results || [];

          const passengersData = passengersForBooking.map((p) => {
            const nationalityObj = nationalityList.find(
              (n) => Number(n.idNationality) === Number(p.id_nationality)
            );

            return {
              email: p.email || "-",
              mobileNo: p.mobileNo || "-",
              firstName: p.firstName || "-",
              lastName: p.lastName || "-",
              age: p.age || "-",
              gender: p.gender || "-",
              nationality: nationalityObj?.nationality_name || "ไม่ระบุ",
            };
          });

          const emailPayload = {
            recipient: yachtOwnerEmail,
            subject: `Payment Success - Booking #${bookingId}`,
            dear: yachtOwnerData?.name_yacht || "Owner",
            passengers: passengersData.length ? passengersData : [],
            paymentType: paymentMethod,
            depositAmount: matchedBooking.sum_all_price,
            cardNumberLast4:
              paymentMethod === "Credit / Debit Cards"
                ? cardNumber.slice(-4)
                : null,
            slipImageUrl:
              paymentMethod === "Bank Transfer" ? base64Image : null,
            paymentDate: new Date().toISOString(),
            idBooking: bookingId,
            yachtName: matchedBooking.yacht_name,
            rateType: matchedBooking.activity_type,
            activity_date: matchedBooking.activity_date,
            adult: matchedBooking.adult || 0,
            child: matchedBooking.child || 0,
            infant: matchedBooking.infant || 0,
          };

          console.log("📧 EMAIL PAYLOAD:", emailPayload);

          await dispatch(sendEmailPaymentAction(emailPayload));
        }
      } catch (e) {
        console.warn("Email error:", e);
      }

      // ================= SUCCESS =================
      showSnackbar("Payment successful!", "success");

      setTimeout(() => {
        onHide?.();
        onCloseMainModal?.();
      }, 800);

    } catch (error) {
      console.error("🔥 ERROR:", error);
      showSnackbar("Failed to process payment.", "error");
    }
  };

  const formatCardNumber = (value) => {
    return value
      .replace(/\D/g, "")
      .slice(0, 16)
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };

  const getMaskedCardNumber = (number) => {
    if (!number) return "";

    const clean = number.replace(/\D/g, "");
    if (clean.length < 4) return clean;

    const first4 = clean.slice(0, 4);
    const last4 = clean.slice(-4);
    const masked = `${first4} **** **** ${last4}`;
    return masked;
  };

  const maskedCVV = cvv ? "***" : "";

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        dialogClassName="payment-modal-dialog"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Payment Details")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="mb-3 d-flex flex-wrap gap-3">
              {["Credit / Debit Cards", "Bank Transfer"].map((method) => (
                <Form.Check
                  key={method}
                  type="radio"
                  name="paymentMethod"
                  label={method}
                  id={method}
                  value={method}
                  checked={paymentMethod === method}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
              ))}
            </div>

            {paymentMethod === "Bank Transfer" && (
              <div className="bank-transfer-modal px-4 pt-4 pb-2">
                {/* กรอบบัญชี */}
                <div className="bank-transfer-box d-flex align-items-center rounded p-3 ">
                  <img
                    src={Kbank}
                    alt="Bank Logo"
                    className="bank-transfer-logo me-3 my-3"
                  />
                  <div>
                    <div className="bank-name fw-bold text-success mb-1">
                      {t("Kasikorn Bank")}
                    </div>
                    <div className="bank-account fw-bold mb-1">
                      {t("Account Number")}{" "}
                      <span className="account-number">090-2-40899-1</span>
                    </div>
                    <div className="bank-owner text-dark">
                      {t("Savings Account – Toffee Boutique Co., Ltd.")}
                    </div>
                  </div>
                </div>

                {/* แนบไฟล์ */}
                <div className="mt-4">
                  <div className="fw-semibold mb-2 text-black">
                    {t("Attach your proof of payment.")}
                  </div>
                  <div className="file-upload-wrapper">
                    <label htmlFor="payment-slip" className="file-upload-label">
                      <span className="file-upload-button">
                        {t("Choose File")}
                      </span>

                      <span className="file-upload-name">
                        {slipFile ? slipFile.name : t("No file chosen")}
                      </span>
                    </label>

                    <input
                      id="payment-slip"
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      className="file-upload-input"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                {/* เงื่อนไข */}
                <div className="terms-box mt-4">
                  <div className="fw-bold mb-2">{t("Terms & Conditions")}</div>
                  <ul>
                    <li>
                      {t(
                        "The uploaded file must clearly show the transaction date, amount and reference number."
                      )}
                    </li>
                    <li>
                      {t(
                        "Please ensure that the payment matches the invoice or order number."
                      )}
                    </li>
                    <li>
                      {t(
                        "Payments will be verified within 1–2 business days after upload."
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {paymentMethod === "Credit / Debit Cards" && (
              <div className="credit-card-payment">
                {/* Card Preview */}
                <div className="credit-card-preview">
                  <Cards
                    number={getMaskedCardNumber(cardNumber)}
                    name={cardName}
                    expiry={
                      expiryMonth && expiryYear
                        ? `${expiryMonth}${expiryYear.slice(-2)}`
                        : ""
                    }
                    cvc={maskedCVV}
                    focused={focus}
                  />
                </div>

                {/* Form */}
                <div className="credit-card-form">
                  <Form.Group className="mb-2">
                    <Form.Label className="fs-085rem">
                      {t("Cardholder Name")}
                    </Form.Label>

                    <Form.Control
                      type="text"
                      placeholder={t("Cardholder Name")}
                      value={cardName}
                      onFocus={() => setFocus("name")}
                      onChange={(e) => {
                        const input = e.target.value;
                        const sanitized = input
                          .replace(/[^A-Z\s]/gi, "")
                          .toUpperCase();

                        setCardName(sanitized);
                      }}
                      className="text-sm-padding"
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label className="fs-085rem">
                      {t("Card Number")}
                    </Form.Label>

                    <Form.Control
                      type="text"
                      placeholder={t("Card Number")}
                      value={formatCardNumber(cardNumber)}
                      onFocus={() => setFocus("number")}
                      maxLength={19}
                      onChange={(e) => {
                        const raw = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 16);

                        setCardNumber(raw);
                      }}
                      className="text-sm-padding"
                    />
                  </Form.Group>

                  <div className="row mb-0">
                    <div className="col-12 col-sm-4 mb-2">
                      <Form.Group>
                        <Form.Label className="fs-085rem">
                          {t("Expiry Month")}
                        </Form.Label>

                        <Form.Select
                          value={expiryMonth}
                          onChange={(e) => setExpiryMonth(e.target.value)}
                          className="text-sm-padding"
                        >
                          <option value="">{t("Month")}</option>

                          {[...Array(12)].map((_, i) => (
                            <option
                              key={i}
                              value={String(i + 1).padStart(2, "0")}
                            >
                              {String(i + 1).padStart(2, "0")}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </div>

                    <div className="col-12 col-sm-4 mb-2">
                      <Form.Group>
                        <Form.Label className="fs-085rem">
                          {t("Expiry Year")}
                        </Form.Label>

                        <Form.Select
                          value={expiryYear}
                          onChange={(e) => setExpiryYear(e.target.value)}
                          className="text-sm-padding"
                        >
                          <option value="">{t("Year")}</option>

                          {[...Array(10)].map((_, i) => {
                            const year = new Date().getFullYear() + i;

                            return (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </div>

                    <div className="col-12 col-sm-4 mb-2">
                      <Form.Group>
                        <Form.Label className="fs-085rem">
                          {t("CVV")}
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder={t("CVV")}
                          maxLength={3}
                          value={cvv}
                          onFocus={() => setFocus("cvc")}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            if (value.length <= 3) {
                              setCvv(value);
                            }
                          }}
                          className="text-sm-padding"
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {paymentMethod === "Credit / Debit Cards" && (
              <div className="text-muted fs-09em">
                {t(
                  "By registering the payment information above, you are authorizing Inverz Solutions Co., Ltd. to charge your payment method immediately for any due or past due invoices, as well as for future recurring payments. You may modify this payment at any time by logging into your account."
                )}
              </div>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className="payment-modal-footer">
          <Button
            variant="secondary"
            className="payment-btn payment-btn-close"
            onClick={onHide}
          >
            {t("Close")}
          </Button>

          <Button
            variant="primary"
            className="payment-btn payment-btn-pay"
            onClick={handleSubmit}
          >
            {t("Pay")}
          </Button>
        </Modal.Footer>


      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PaymentModal;
